// extracted by mini-css-extract-plugin
export var copyIcon = "_yq-2";
export var discountCard = "_yq-0";
export var discountCode = "_yq-3";
export var discountContent = "_yq-1";
export var loadingCard = "_yq-4";